export default {
	'errors.providePhoneNumber': 'Por favor ingrese un número de teléfono válido.',
	'errors.provideValidResponses': 'Por favor, proporcione respuestas válidas para todos los campos requeridos.'
};


// WEBPACK FOOTER //
// ./~/@workmarket/translation/dist-es/messages/es-es/errors.js